import { AxiosResponse } from 'axios';
import { AnunciosData, buildAnuncioFormData, GetVoidAnunciosData, syncCodFacCarr } from '../types/Anuncio/AnuncioData';
import { PaginateObj } from '../types/Paginate/PaginateObjt';
import apiInterceptor from '../utils/axios';
import { SeguimientoDTO } from '../types/Seguimiento/SeguimientoDTO';
import { GenericResponse, GenericResponseData, GenericResponseListData } from '../types/Response/GenericResponse';
import { ResponseApi } from '../types/Response/ResponseApi';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APIANUNCIO = 'api/Catalog/anuncios/';

export default class AnuncioService {

    static async GetMisAnuncios(): Promise<Array<AnunciosData>> {
        const response1: AxiosResponse<Array<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIANUNCIO}`);
        return response1.data;
    }

    static async GetMiAnuncioHistorial(id: number): Promise<GenericResponseListData<SeguimientoDTO>> {
        try {
            const response: AxiosResponse<Array<SeguimientoDTO>> = await apiInterceptor.get(`${SERV_BACK}${APIANUNCIO}historial/${id}`);
            if (response.status === 200) {
                return {
                    status: response.status,
                    message: 'Operación completada con éxito',
                    list_data: response.data
                };
            } else {
                console.error('Respuesta no exitosa:', response.status);
                return {
                    status: response.status,
                    message: `Error: Código de estado ${response.status}`,
                    list_data: []
                };
            }
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);
            return {
                status: 500,
                message: 'Error al realizar la solicitud',
                list_data: []
            };
        }
    }

    static async GetMisAnunciosPaginate(estado: string): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIANUNCIO}page/${estado}`);
        return response1.data;
    }
    static async GetPageByNumber(link: string, pageNum: number): Promise<PaginateObj<AnunciosData>> {
        const baseUrl = link.substring(0, link.indexOf('?'));
        const params = new URLSearchParams({
            pageNumber: pageNum.toString(),
            pageSize: "8", // Tamaño fijo por página
        });
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${baseUrl}?${params.toString()}`);
        return response1.data;
    }
    static async GetMisAnunciosPaginateSearch(estado: string, name: string): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIANUNCIO}search/${estado}/${name}`);
        return response1.data;
    }

    static async GetMiAnuncio(id: number): Promise<ResponseApi<AnunciosData>> {
        const response: AxiosResponse<ResponseApi<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIANUNCIO}${id}`);
        return response.data;
    }
    
    static async CreateAnuncio(anuncio: AnunciosData): Promise<ResponseApi<AnunciosData>> {
        let forma = buildAnuncioFormData(anuncio)
        const response: AxiosResponse<ResponseApi<AnunciosData>> = await apiInterceptor.post(`${SERV_BACK}${APIANUNCIO}`,
            forma,);
        //console.log(response);
        return response.data;
    }

    static async UpdateAnuncio(anuncio: AnunciosData): Promise<ResponseApi<AnunciosData>> {
        //console.log(anuncio)
        let forma = buildAnuncioFormData(anuncio);
        const response: AxiosResponse<ResponseApi<AnunciosData>> = await apiInterceptor.put(`${SERV_BACK}${APIANUNCIO}${anuncio.idAnuncio}`,
            forma,
            {
                headers: {
                    "Content-type": "multipart/form-data",
                },
            });
        //console.log(response);
        return response.data;
    }

    static async DeleteMiAnuncio(id: number): Promise<GenericResponse> {
        try {
            const response: AxiosResponse<any> = await apiInterceptor.delete(`${SERV_BACK}${APIANUNCIO}${id}`);
            if (response.status === 204) {
                return {
                    status: response.status,
                    message: 'Operación completada con éxito',
                };
            } else {
                //console.error('Respuesta no exitosa:', response.status);
                return {
                    status: response.status,
                    message: `Error: Código de estado ${response.status}`,
                };
            }
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);
            return {
                status: 500,
                message: 'Error al realizar la solicitud',
            };
        }

    }

    static async GetPage(link: string): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${link}`);
        return response1.data;
    }
}